import { render, staticRenderFns } from "./Vin.vue?vue&type=template&id=45da0669&"
import script from "./Vin.vue?vue&type=script&lang=js&"
export * from "./Vin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports